import { createMemo, type Accessor } from "solid-js"
import type { Engine } from "../../lib/core/engine/Engine.type"
import getEntityXYGridMap from "../../lib/core/entity/EntityXYGridMap/getEntityXYGridMap"
import type { EntityXYGridMap } from "./createFirstPlayerIdMemo"
import createSharedCachedFactory from "./createSharedCachedFactory"

export const createSharedEntityXYGridMapMemo = createSharedCachedFactory((engine: Engine): Accessor<EntityXYGridMap> => {
  const memo = createMemo(() => {
    return getEntityXYGridMap(engine.state.ents)
  })
  return memo
})

